import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SpendEverywhere } from '../components/SpendEverywhere';
import { HowItWorks } from '../components/HowItWorks';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-533">
      <Header data-id="element-534" />
      <Hero data-id="element-535" />
      <SpendEverywhere data-id="element-536" />
      <HowItWorks data-id="element-537" />
      <Footer data-id="element-538" />
      <WhatsAppButton data-id="element-539" />
    </div>;
}